<app-report-runner
  reportType="mediation"
  title="Mediation Report"
  description="Mediations conducted and resolved during the selected period."
/>
